import Layout from '../../../layout/Layout'
import PatternCreate from 'components/organisms/PatternCreate/PatternCreate'
import Breadcrumb from 'components/atoms/Breadcrumb/Breadcrumb'
import arrowIcon from '../../../assets/arrowNext.png'

export default function CreateTemplatePage() {
    const breadcrumbNavigate = [
        {
            label: 'Plantillas',
            path: '/templates',
        },
        {
            label: 'Crear Plantilla',
            path: '/templates/create',
        },
    ]

    return (
        <Layout>
            <div className='flex justify-between px-6 mt-10 items-end'>
                <div>
                    <Breadcrumb
                        items={breadcrumbNavigate}
                        separator={<img src={arrowIcon} alt="arrowIcon" />}
                        title="Crear nueva plantilla"
                    />
                </div>
            </div>
            <PatternCreate />
        </Layout>
    )
}
